export default __webpack_public_path__ + "locales/nl/FormGallery.json?hash=b3b44ff4ab5e53679934bfa6833a2e4d";